import React, { Fragment } from "react";

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Alarms from "../Alarms";
import RunningPeriods from "../RunningPeriods/RunningPeriodsIndex";
import Login from "../Core/Login";
import Layout from "./Layout";
import { store } from "./Store";
import HistoryListener from "./HistoryListener";
import RunningPeriodsCount from "../RunningPeriodsCount/CountIndex"
import MachineHealth from "../MachineHealth/MachineHealthIndex"
import MachineTimes from "../MachineTimes/MachineTimesIndex"
import Mdc from "../MDC/MdcIndex";
import MdcTotals from "../MDCTotals";
import Partwearout from "../PartWearOut";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { amChartsKey } from "../Common/Constants";
import { injectStore } from "./http";

injectStore(store);

function App() {

    am4core.addLicense(amChartsKey);
  return (
      <Provider store={store}>
          <Router>
              <HistoryListener>
                  <Fragment>
                      <Login>
                          <Layout>
                              <Routes>
                                  <Route path="/" element={<MachineTimes />} />
                    <Route path="/alarms" element={<Alarms/>}>
                      <Route path="/alarms/:queryparams" element={<Alarms/>}  />
                    </Route>
                    <Route path="/runningperiodcategories" element={<RunningPeriods/>} />
                    <Route path="/runningperiodcount" element={<RunningPeriodsCount/>} />
                    <Route path="/interrupt" element={<MachineHealth />} />
                                  <Route path="/machinetimes" element={<MachineTimes />} />
                                  <Route path="/machinetimes/:queryparams" element={<MachineTimes />} />
                                  <Route path="/mdc" element={<Mdc />} />
                                  <Route path="/mdc/:queryparams" element={<Mdc />} />
                                  <Route path="/mdcTotals" element={<MdcTotals />} />

                                  <Route path="/partwearout" element={<Partwearout />} />
                                  <Route path="/partwearout/:queryparams" element={<Partwearout />} />
                              </Routes>
                          </Layout>
                      </Login>
                  </Fragment>
              </HistoryListener>
          </Router>
      </Provider>
  );
}

export default App;
